import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { VideoSearchResult } from '../../model/video-search-result.model';
import { VideoStreamingService } from '../../controller/video-streaming.service';

@Component({
  selector: 'app-video-thumbnail',
  templateUrl: './video-thumbnail.component.html',
  styleUrls: ['./video-thumbnail.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class VideoThumbnailComponent implements OnInit, OnChanges {

  @Input() video: VideoSearchResult = null;

  videoThumbnailUrl: string = null;

  constructor(
    private videoStreamingService: VideoStreamingService

  ) { }
  ngOnChanges(): void {
    this.refresh();
  }

  ngOnInit() {
    this.refresh();
  }

  public refresh() {
    if (!this.video) {
      return;
    }
    setTimeout(
      async () => {
        await this.getThumbnail();
      }
    );
  }

  private async getThumbnail() {
    this.videoThumbnailUrl = await this.videoStreamingService.getThumbnail(this.video.id);
  }



  public isLoading(): boolean {
    return !this.video || !this.videoThumbnailUrl;
  }

}
